export const catalogData = [
  {
    id: 1,
    productClass: "REAL Compound",
    clogP: "1.446",
    mv: "107.2",
    hbd: "1",
    hba: "1",
    rotb: "1",
    fap3: "0.1429",
  },
  {
    id: 2,
    productClass: "REAL Compound",
    clogP: "1.446",
    mv: "107.2",
    hbd: "1",
    hba: "1",
    rotb: "1",
    fap3: "0.1429",
  },
  {
    id: 3,
    productClass: "REAL Compound",
    clogP: "1.446",
    mv: "107.2",
    hbd: "1",
    hba: "1",
    rotb: "1",
    fap3: "0.1429",
  },
  {
    id: 4,
    productClass: "REAL Compound",
    clogP: "1.446",
    mv: "107.2",
    hbd: "1",
    hba: "1",
    rotb: "1",
    fap3: "0.1429",
  },
  {
    id: 5,
    productClass: "REAL Compound",
    clogP: "1.446",
    mv: "107.2",
    hbd: "1",
    hba: "1",
    rotb: "1",
    fap3: "0.1429",
  },
  {
    id: 6,
    productClass: "REAL Compound",
    clogP: "1.446",
    mv: "107.2",
    hbd: "1",
    hba: "1",
    rotb: "1",
    fap3: "0.1429",
  },
  {
    id: 7,
    productClass: "REAL Compound",
    clogP: "1.446",
    mv: "107.2",
    hbd: "1",
    hba: "1",
    rotb: "1",
    fap3: "0.1429",
  },
  {
    id: 8,
    productClass: "REAL Compound",
    clogP: "1.446",
    mv: "107.2",
    hbd: "1",
    hba: "1",
    rotb: "1",
    fap3: "0.1429",
  },
];

export const tableCustomStyles = {
  headRow: {
    style: {
      color: "#6a7c8e",
      backgroundColor: "#fff",
      fontSize: "15px",
      fontWeight: "600",
    },
  },
  striped: {
    backgroundColor: "#f9fafb",
  },
};
